// extracted by mini-css-extract-plugin
export default {"item":"Paramaters_item__Mp5F1","jobSettings":"Paramaters_jobSettings__jhg3u","input":"Paramaters_input__MkLWh","checkboxGroup":"Paramaters_checkboxGroup__1sZmR"};